import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FormHelperService } from '../core/services';
import { DropdownValue } from '../shared/dropdown.model';
import { IPublisherInfoModel, IEditPublisherViewModel } from './publisher.model';
import { PublisherGroupSelectionComponent } from '../shared/publisher-group-selection.component';

@Component({
    selector: 'publisher-info-modal',
    moduleId: module.id,
    templateUrl: 'publisher-info-modal.component.html'
})

export class PublisherInfoComponent implements OnInit {
    publisherInfoForm: FormGroup;
    showSignatureError: boolean = false;
    showNameError: boolean = false;
    @Input() publishers: Array<IEditPublisherViewModel> = [];
    selectedColor: string = '';

    @Output()
    public publisherInfo: EventEmitter<IPublisherInfoModel> = new EventEmitter<IPublisherInfoModel>();

    @ViewChild("publisherGroupSelector") publisherGroupSelector: PublisherGroupSelectionComponent;

    constructor(
        private formBuilder: FormBuilder,
        private formHelperService: FormHelperService) { }

    ngOnInit(): void {
        this.publisherInfoForm = this.formBuilder.group({
            nameField: ['', [Validators.required]],
            publisherGroupIdField: ['', [Validators.required]],
            requiresSignatureField: ['', []],
            signatureFormatField: ['', []],
            showRatingsField: ['', []],
            colorField: ['', []]
        });
        this.publisherInfoForm.controls["signatureFormatField"].setValue('{secretKey}{publisherId}{userExternalRef}{clickId}');
    }

    public checkSignatureIfRequired() {
        if (this.publisherInfoForm.value.requiresSignatureField) {
            if (this.publisherInfoForm.value.signatureFormatField == undefined || this.publisherInfoForm.value.signatureFormatField == '') {
                this.showSignatureError = true;
                return true;
            }
        }
        this.showSignatureError = false;
        return false;
    }

    private checkIfNameIsUnique() {
        let found = this.publishers.find(x => x.name == this.publisherInfoForm.value.nameField);
        if (found != undefined && found != null)
            this.showNameError = true;
        else this.showNameError = false;
        return this.showNameError;
    }

    showCreatePublisherInfo() {
        $('#publisherInfoModal').modal('show');
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.publisherInfoForm, controlName, validator)
    }

    onPublisherGroupsClicked() {
        $(".configurable-dropdown .list")
            .css("left", function () {
                return $(this).parent().position().left;
            })
            .css("top", function () {
                return $(this).parent().position().top;
            })
            //.css('max-height', '180px')
            .css('overflow-y', 'scroll').css('position', 'fixed');
    }

    onPublisherGroupValueChanged(item: DropdownValue) {
        if (item.value === 0) {
            this.publisherInfoForm.controls["publisherGroupIdField"].setValue(null);
        } else {
            this.publisherInfoForm.controls["publisherGroupIdField"].setValue(item.value);
        }
    }

    onNext(event: any) {
        if (this.checkSignatureIfRequired()) return;

        if (this.checkIfNameIsUnique()) return;

        let result = new IPublisherInfoModel();
        result.name = this.publisherInfoForm.value.nameField;
        result.groupId = this.publisherInfoForm.value.publisherGroupIdField;
        result.requiresSignature = this.publisherInfoForm.value.requiresSignatureField;
        result.signature = this.publisherInfoForm.value.signatureFormatField;
        result.showRatings = this.publisherInfoForm.value.showRatingsField;
        result.color = this.selectedColor;
        this.publisherInfo.emit(result);
        $('#publisherInfoModal').modal('hide');
    }

    clearModal() {
        this.publisherInfoForm.reset();
        this.publisherGroupSelector.loadItems(null, true);
        this.publisherInfoForm.controls["signatureFormatField"].setValue('{secretKey}{publisherId}{userExternalRef}{clickId}');
        this.selectedColor = '';
    }

    onColorPickerClicked(value) {
        let cp = $('.color-picker');
        $(cp)
            .css("left", function () {
                return $(this).parent().parent().position().left;
            })
            .css("top", '50%')
            .css('color', '#e6e6e6')
            .css('background-color', '#333b46');

        $('.color-picker .arrow.arrow-bottom').css('display', 'none');
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publisher-info-modal.component.ts